import LegalLayout, { LegalSection } from "./LegalLayout";

export default function TerminosPage() {
  return (
    <LegalLayout num="§" chapter="Legal" title="Términos y Condiciones" updated="21 de julio de 2026" testId="terms-page">
      <LegalSection title="1. Objetivo y alcance">
        <p>
          1.1 En SERVICIOS COMERCIALES ECLICK MEXICO, S.A. DE C.V., nos comprometemos a garantizar la confidencialidad y seguridad de la
          información de nuestros clientes y usuarios. La presente Política de Privacidad establece las prácticas de
          https://b2b.eclickgo.com en cuanto a la recopilación, uso, divulgación y protección de la información personal obtenida a través
          de nuestro sitio web de comercio electrónico. Al utilizar nuestros productos, usted acepta las disposiciones contenidas en esta
          política.
        </p>
      </LegalSection>

      <LegalSection title="2. Información que recopilamos">
        <p>
          2.1 <span className="font-semibold text-ecdeep">Datos personales:</span> Podemos recolectar información como nombres,
          direcciones, números telefónicos, direcciones de correo electrónico y otros datos proporcionados voluntariamente durante el
          registro y proceso de compra en nuestro sitio.
        </p>
        <p>
          2.2 <span className="font-semibold text-ecdeep">Información de pago:</span> Al realizar una compra, podemos recopilar información
          financiera, como números de tarjetas de crédito o débito, necesarios para procesar pagos y completar transacciones.
        </p>
        <p>
          2.3 <span className="font-semibold text-ecdeep">Información del dispositivo:</span> Recabamos datos sobre el dispositivo que
          utiliza para acceder a nuestro sitio, incluyendo dirección IP, tipo de navegador, versión, sistema operativo y otros detalles
          similares.
        </p>
      </LegalSection>

      <LegalSection title="3. Uso de la información">
        <p>
          3.1 <span className="font-semibold text-ecdeep">Uso interno:</span> La información recopilada se utiliza para mejorar nuestros
          servicios, procesar pagos, enviar notificaciones importantes y brindar asistencia al cliente.
        </p>
        <p>
          3.2 <span className="font-semibold text-ecdeep">Comunicaciones de marketing:</span> Con su consentimiento, podemos utilizar sus
          datos de contacto para enviarle comunicaciones de marketing acerca de nuestros productos, promociones u ofertas especiales. Tiene
          la opción de optar por no recibir estas comunicaciones en cualquier momento.
        </p>
      </LegalSection>

      <LegalSection title="4. Divulgación de la información">
        <p>
          4.1 <span className="font-semibold text-ecdeep">Proveedores de servicios:</span> Compartimos información personal con proveedores
          de servicios externos que colaboran en la operación de nuestro negocio, como procesadores de pagos, servicios de envío y
          proveedores de alojamiento web. Estos terceros están obligados a proteger la información de acuerdo con esta política y las leyes
          pertinentes.
        </p>
        <p>
          4.2 <span className="font-semibold text-ecdeep">Cumplimiento legal:</span> Podemos revelar información personal cuando sea
          requerido por la ley o cuando consideremos de buena fe que la divulgación es necesaria para proteger nuestros derechos legales,
          cumplir con procesos legales, responder a solicitudes gubernamentales o investigar actividades ilícitas.
        </p>
      </LegalSection>

      <LegalSection title="5. Seguridad de la información">
        <p>
          Nos esforzamos por mantener la seguridad de la información personal mediante la implementación de medidas técnicas,
          administrativas y físicas. No obstante, no podemos garantizar la seguridad absoluta de la información en entornos en línea.
        </p>
      </LegalSection>

      <LegalSection title="6. Sus derechos y opciones">
        <p>
          6.1 <span className="font-semibold text-ecdeep">Acceso y actualización:</span> Usted tiene derecho a acceder y actualizar su
          información personal a través de nuestro sitio web o poniéndose en contacto con nuestro equipo de atención al cliente en
          soluciones@eclick.mx.
        </p>
        <p>
          6.2 <span className="font-semibold text-ecdeep">Retención de datos:</span> Conservaremos su información personal durante el
          tiempo necesario para cumplir con los propósitos descritos en esta política, a menos que la ley exija o permita un período de
          retención más prolongado.
        </p>
      </LegalSection>

      <LegalSection title="7. Cambios en la Política de Privacidad">
        <p>
          Nos reservamos el derecho de modificar esta política en cualquier momento. Cualquier cambio será publicado en nuestro sitio web
          y, en caso de modificaciones significativas, se le notificará de manera adecuada.
        </p>
      </LegalSection>

      <LegalSection title="8. Acceso a los datos">
        <p>SERVICIOS COMERCIALES ECLICK MEXICO, S.A. DE C.V., es el responsable del tratamiento de datos y tiene su domicilio en:</p>
        <div className="rounded-2xl border border-ecnavy/10 bg-ecmist p-6 text-sm text-ecdeep">
          NETWORK OFICINAS AMERICAS, PASEO LAS AMERICAS NUM 31 PISO 1, COL. LOMAS VERDES 3RA SECC, NAUCALPAN DE JUAREZ, ESTADO DE MÉXICO,
          C.P. 53121
        </div>
        <p>
          Si no desea que su información personal sea tratada, puede rechazar el tratamiento. Asimismo, tiene derecho a ejercer los
          derechos ARCO (Acceso, Rectificación, Cancelación y Oposición), limitar el uso de su información o revocar el consentimiento
          previamente otorgado para el tratamiento de sus datos personales, en la medida máxima permitida por la ley.
        </p>
        <p>
          Cualquier duda, consulta o solicitud relacionada con su información personal puede dirigirla por escrito a soluciones@eclick.mx,
          cristian@eclick.mx o carmen@eclick.mx. Para que podamos atender su solicitud, incluya en su comunicación: (i) su nombre completo
          y copia de su identificación personal, o cualquier documento que acredite su identidad o representación en nombre del titular de
          los datos pertinentes, y (ii) una descripción clara de su solicitud.
        </p>
        <p>Responderemos a su solicitud por correo electrónico dentro de los plazos establecidos por la ley aplicable.</p>
      </LegalSection>
    </LegalLayout>
  );
}
